var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "inline-block relative select-none",
      class: {
        "w-20 mt-1_5 mb-1_5 md_mb-0": !_vm.wrap || _vm.isWhitelabel,
        "max-w-lg py-2 px-1 product-group-product--container bg-white":
          _vm.wrap && !_vm.isWhitelabel,
        "product-group-product--container-three-columns":
          _vm.wrap && _vm.threeColumns
      }
    },
    [
      _vm.isUserAdmin && !_vm.disabled
        ? _c(
            "svg",
            {
              staticClass: "h-1_5 w-1_5 top-1 right-1 absolute cursor-pointer",
              attrs: { viewBox: "0 0 24 24", taxindex: "0" },
              on: {
                click: _vm.hideCampaign,
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.hideCampaign($event)
                }
              }
            },
            [
              _c("path", {
                staticClass: "text-brand",
                attrs: {
                  fill: "currentColor",
                  d:
                    "M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z"
                }
              })
            ]
          )
        : _vm._e(),
      _c(
        "router-link",
        {
          staticClass:
            "transition-250 transition-border h-full flex flex-wrap justify-center items-center bg-white",
          class: {
            "text-center": _vm.wrap,
            "mx-_625 product-group-product": !_vm.wrap || _vm.isWhitelabel
          },
          attrs: { to: _vm.uri }
        },
        [
          _c("img", {
            directives: [
              {
                name: "lazy",
                rawName: "v-lazy",
                value: _vm.image,
                expression: "image"
              }
            ],
            class: {
              "w-16": _vm.wrap,
              "pb-1 px-1 lg_px-2 pt-1 w-full": !_vm.wrap || _vm.isWhitelabel
            },
            attrs: { alt: _vm.campaign.name }
          }),
          _vm.wrap && !_vm.isWhitelabel
            ? [
                _c(
                  "div",
                  { staticClass: "text-xl mt-1 break-anywhere w-full" },
                  [_vm._v(_vm._s(_vm.campaign.name))]
                ),
                _c("div", { staticClass: "text-xl text-brand mt-_25 w-full" }, [
                  _vm._v(
                    _vm._s(
                      _vm.currency(
                        _vm.campaign.selling_price || _vm.campaign.price,
                        _vm.currencyInfo
                      )
                    )
                  )
                ])
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "text-3xl md_text-xl text-brand-secondary px-1 w-full leading-none break-words whitespace-normal"
                  },
                  [_vm._v(_vm._s(_vm.campaign.name))]
                ),
                !_vm.hidePrice
                  ? _c("div", { staticClass: "px-1 pb-1 w-full mt-_5" }, [
                      _c(
                        "span",
                        {
                          staticClass: "text-2xl md_text-lg text-brand mr-_75"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.currency(
                                _vm.campaign.selling_price ||
                                  _vm.campaign.price,
                                _vm.currencyInfo
                              )
                            )
                          )
                        ]
                      ),
                      _vm.campaign.msrp
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "text-xl md_text-base text-brand-secondary-300 line-through font-light"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.currency(
                                    _vm.campaign.msrp,
                                    _vm.currencyInfo
                                  )
                                )
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }